import { ResponseData, RelationObject } from 'api/types'
import { ViewData } from 'interfaces/navigationPage.interface'
import { IModel } from 'interfaces/model.interface'
import { isRelational } from './relational'

export function resolveAirtableBase<TModel extends IModel<any>>(
  rawIds: ResponseData,
  model: TModel,
  viewData: ViewData
): ViewData['airtableBase'] {
  if (
    rawIds &&
    isRelational(rawIds) &&
    Array.isArray(rawIds) &&
    rawIds.length > 0
  ) {
    const baseList = rawIds.map((r) => (r as RelationObject).base)
    const endpointList = rawIds.map((r) => (r as RelationObject).endpoint)

    if (!endpointList.every((e) => e === endpointList[0])) {
      throw new Error(
        `Inconsistent Airtable endpoints detected: ${endpointList.join(', ')}`
      )
    }

    if (!baseList.every((b) => b === baseList[0])) {
      throw new Error(
        `Inconsistent Airtable bases detected: ${baseList.join(', ')}`
      )
    }

    if (endpointList[0] !== model.endpoint) {
      throw new Error(
        `Inconsistent Airtable endpoint detected: ${endpointList[0]} does not match model endpoint ${model.endpoint}`
      )
    }

    return baseList[0] as typeof viewData.airtableBase
  }

  return viewData.airtableBase
}
